import { HttpFunctionResult } from "src/app/_interfaces/HttpFunctionResult";

export enum WawiConnectorType {
    WAWITOGO_WEB = 'WAWITOGO_WEB',
    WAWITOGO_APP = 'WAWITOGO_APP',
    WEBCONNECTOR = 'WEBCONNECTOR',
    NOTHING = 'NOTHING',
}

export type WawiConnectorTypeExecutable = WawiConnectorType.WAWITOGO_WEB | WawiConnectorType.WAWITOGO_APP | WawiConnectorType.WEBCONNECTOR;

export interface WawiConnectorExecutable{
    executable: true
    type: WawiConnectorTypeExecutable
    executeCommand(command: string): Promise<HttpFunctionResult>
    openArticle(articleId: number): Promise<HttpFunctionResult>
    openCustomer(customerId: number): Promise<HttpFunctionResult>
    openProcess(processId: number): Promise<HttpFunctionResult>
}

export interface WawiConnectorNonExecutable{
    executable: false
    type: WawiConnectorType.NOTHING
}